import _get from "lodash/get";
import styled from 'styled-components';
import { rem } from 'polished';
import { baseTheme } from '~base-theme';
var ItemImageContainer = styled.div.withConfig({
  displayName: "ItemImageContainer",
  componentId: "sc-1d5cp3l-0"
})(["border-radius:", ";flex-shrink:0;height:", ";margin-right:", ";max-width:", ";overflow:hidden;width:100%;"], function (_ref) {
  var theme = _ref.theme;
  return rem(_get(theme, 'base.borderRadius.default', baseTheme.base.borderRadius.default));
}, function (_ref2) {
  var $height = _ref2.$height;
  return rem($height);
}, rem(8), function (_ref3) {
  var $width = _ref3.$width;
  return rem($width);
});
export default ItemImageContainer;